module.exports = __webpack_public_path__ + "static/media/truck-travel@2x.24ebc716.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/truck-travel@2x.png
// module id = 1897
// module chunks = 0